<template>
  <div>
    <v-treeview
      :active.sync="active"
      :items="treeItems"
      :load-children="getChildren"
      :open.sync="open"
      item-key="_id"
      open-on-click
      activatable
      transition
      style="overflow-y: auto"
    >
      <template v-slot:prepend="{ item }">
        <v-icon v-if="!item.type">
          {{ open.includes(item._id) ? "mdi-folder-open" : "mdi-folder" }}
        </v-icon>
        <v-icon v-else-if="item.type === 'youtube'"> mdi-video </v-icon>
        <v-icon v-else> mdi-file </v-icon>
      </template>

      <template v-slot:label="{ item }">
        <div
          class="d-flex align-center justify-space-between w-100"
          style="max-width: 100%"
          @mouseover="hoveredId = item._id"
          @mouseleave="hoveredId = null"
          @click="item.type ? openFile(item) : {}"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <span
                v-bind="attrs"
                v-on="on"
                style="
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  max-width: 100%;
                  display: inline-block;
                  font-size: 0.9rem;
                "
              >
                {{ item.name }}
              </span>
            </template>
            <span>{{ item.name }}</span>
          </v-tooltip>
          <div
            v-if="currentUser.is_admin && hoveredId === item._id"
            class="d-flex align-center"
          >
            <v-tooltip bottom v-if="item.type">
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="d-flex align-center ml-2"
                  v-bind="attrs"
                  v-on="on"
                  style="cursor: default"
                >
                  <span style="margin-right: 5px">{{
                    item.viewCount || 0
                  }}</span>
                  <v-icon style="font-size: 20px">mdi-eye</v-icon>
                </div>
              </template>
              <span>Nombre de vues</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  v-bind="attrs"
                  v-on="on"
                  @click.stop="
                    item.type ? onModifyFile(item) : onModifyDirectory(item)
                  "
                  class="ml-2"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>Modifier le {{ item.type ? "fichier" : "dossier" }}</span>
            </v-tooltip>

            <template v-if="!item.type">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="onAddFile(item)"
                    class="ml-2"
                  >
                    <v-icon>mdi-file-plus</v-icon>
                  </v-btn>
                </template>
                <span>Ajouter un fichier</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="onAddDirectory(item)"
                    class="ml-2"
                  >
                    <v-icon>mdi-folder-plus</v-icon>
                  </v-btn>
                </template>
                <span>Ajouter un dossier</span>
              </v-tooltip>

              <!-- <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    @click.stop="onImport(item)"
                    class="ml-2"
                  >
                    <v-icon>mdi-folder-zip</v-icon>
                  </v-btn>
                </template>
                <span>Importer (.zip)</span>
              </v-tooltip> -->
            </template>
          </div>
        </div>
      </template>
    </v-treeview>
    <v-dialog v-model="addDirectory.opened" width="600">
      <DialogAddDirectory
        @close="addDirectory.opened = false"
        :parent="addDirectory.parent"
      />
    </v-dialog>
    <v-dialog v-model="addFile.opened" width="600">
      <DialogAddFile @close="addFile.opened = false" :parent="addFile.parent" />
    </v-dialog>
    <v-dialog v-model="modifyDirectory.opened" width="600">
      <DialogModifyDirectory
        @close="modifyDirectory.opened = false"
        :directory="modifyDirectory.directory"
        :parent="modifyDirectory.parent"
      />
    </v-dialog>
    <v-dialog v-model="modifyFile.opened" width="600">
      <DialogModifyFile
        @close="modifyFile.opened = false"
        :file="modifyFile.file"
        :parent="modifyFile.parent"
      />
    </v-dialog>
    <v-dialog v-model="importZip.opened" width="600">
      <DialogImport
        @close="importZip.opened = false"
        :directoryId="importZip.directoryId"
      />
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DialogAddDirectory from "./DialogAddDirectory.vue";
import DialogAddFile from "./DialogAddFile.vue";
import DialogModifyDirectory from "./DialogModifyDirectory.vue";
import DialogModifyFile from "./DialogModifyFile.vue";
import DialogImport from "./DialogImport.vue";

export default {
  name: "Tree",
  components: {
    DialogAddDirectory,
    DialogAddFile,
    DialogModifyDirectory,
    DialogModifyFile,
    DialogImport,
  },
  data() {
    return {
      url: location.pathname,
      open: [],
      active: [],
      hoveredId: null,
      suppressUrlUpdate: false,

      addDirectory: {
        opened: false,
        parent: null,
      },
      addFile: {
        opened: false,
        parent: null,
      },
      modifyDirectory: {
        opened: false,
        directory: null,
        parent: null,
      },
      modifyFile: {
        opened: false,
        file: null,
        parent: null,
      },
      importZip: {
        opened: false,
        directoryId: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      getTreeItems: "leodata/getTreeItems",
      currentUser: "user/getUser",
    }),
    treeItems() {
      return this.getTreeItems;
    },
  },
  created() {
    this.$store.dispatch("leodata/getRootItems").then(() => {
      this.expandTreeFromPath();
    });
  },
  methods: {
    findById(items, id) {
      for (const it of items) {
        if (it._id === id) return it;
        if (it.children?.length) {
          const found = this.findById(it.children, id);
          if (found) return found;
        }
      }
      return null;
    },
    updateUrlForNode(item) {
      this.url = this.getFullPath(item);
      window.history.replaceState({}, "", this.url);
      localStorage.setItem("leodata.lastPath", this.url);
    },
    getFullPath(item) {
      let path = [item.name];
      let parent = this.findParent(this.treeItems, item._id);
      while (parent) {
        path.unshift(parent.name);
        parent = this.findParent(this.treeItems, parent._id);
      }
      return `/leodata/${path.join("/")}`;
    },
    findParent(items, childId) {
      for (const item of items) {
        if (item.children?.some((c) => c._id === childId)) {
          return item;
        }
        if (item.children?.length) {
          const found = this.findParent(item.children, childId);
          if (found) return found;
        }
      }
      return null;
    },
    changeUrl(item) {
      this.url = this.getFullPath(item);
      window.history.replaceState({}, "", this.url);
    },
    async getChildren(item) {
      try {
        return await this.$store.dispatch("leodata/fetchChildren", item._id);
      } catch (error) {
        return [];
      }
    },
    async expandTreeFromPath() {
      let segments = location.pathname
        .replace(/^\/leodata\/?/, "")
        .split("/")
        .filter(Boolean)
        .map(decodeURIComponent);

      if (segments.length === 0) {
        if (!localStorage.getItem("leodata.lastPath")) return;
        segments = localStorage
          .getItem("leodata.lastPath")
          .replace(/^\/leodata\/?/, "")
          .split("/")
          .filter(Boolean)
          .map(decodeURIComponent);
      }

      this.suppressUrlUpdate = true;
      this.open = [];

      let currentItems = this.treeItems;
      let lastValidNode = null;

      for (const name of segments) {
        const node = currentItems.find((n) => n.name === name);
        if (!node) break;
        lastValidNode = node;
        if (node.type) {
          this.active = [node._id];
          this.$emit("openFile", node._id);
          break;
        }
        if (!node.children || node.children.length === 0) {
          await this.$store.dispatch("leodata/fetchChildren", node._id);
        }
        if (!this.open.includes(node._id)) {
          this.open = [...this.open, node._id];
        }
        currentItems = node.children || [];
      }

      if (lastValidNode) {
        this.updateUrlForNode(lastValidNode);
      } else {
        window.history.replaceState({}, "", "/leodata");
      }

      this.$nextTick(() => {
        this.suppressUrlUpdate = false;
      });
    },
    openFile(item) {
      this.changeUrl(item);
      this.$emit("openFile", item._id);
    },
    async onAddDirectory(item) {
      try {
        const parent = await this.$store.dispatch(
          "leodata/getDirectoryDetails",
          item._id
        );
        const content = await this.$store.dispatch(
          "leodata/getDirectoryContent",
          parent._id
        );
        this.addDirectory.parent = parent;
        this.addDirectory.parent.children = content.children;
        this.addDirectory.opened = true;
      } catch (error) {
        console.error("Error fetching directory details:", error);
      }
    },
    async onAddFile(item) {
      try {
        const parent = await this.$store.dispatch(
          "leodata/getDirectoryDetails",
          item._id
        );
        const content = await this.$store.dispatch(
          "leodata/getDirectoryContent",
          parent._id
        );
        this.addFile.parent = parent;
        this.addFile.parent.children = content.children;
        this.addFile.opened = true;
      } catch (error) {
        console.error("Error fetching directory details:", error);
      }
    },
    async onModifyDirectory(item) {
      try {
        const directory = await this.$store.dispatch(
          "leodata/getDirectoryDetails",
          item._id
        );
        const parent = await this.$store.dispatch(
          "leodata/getDirectoryDetails",
          directory.parent
        );
        const children = await this.$store.dispatch(
          "leodata/getDirectoryContent",
          directory.parent
        );
        parent.children = children.children;
        this.modifyDirectory.directory = directory;
        this.modifyDirectory.parent = parent;
        this.modifyDirectory.opened = true;
      } catch (error) {
        console.error("Error fetching directory details:", error);
      }
    },
    async onModifyFile(item) {
      try {
        const file = await this.$store.dispatch(
          "leodata/getFileDetails",
          item._id
        );
        const parent = await this.$store.dispatch(
          "leodata/getDirectoryDetails",
          file.parent
        );
        const children = await this.$store.dispatch(
          "leodata/getDirectoryContent",
          file.parent
        );
        parent.children = children.children;
        this.modifyFile.file = file;
        this.modifyFile.parent = parent;
        this.modifyFile.opened = true;
      } catch (error) {
        console.error("Error fetching directory details:", error);
      }
    },
    async onImport(item) {
      this.importZip.directoryId = item._id;
      this.importZip.opened = true;
    },
  },
  watch: {
    open(newOpen, oldOpen) {
      if (this.suppressUrlUpdate) return;

      const added = newOpen.find((id) => !oldOpen.includes(id));
      const targetId = added ?? newOpen[newOpen.length - 1];
      if (!targetId) return;

      const node = this.findById(this.treeItems, targetId);
      if (node) this.updateUrlForNode(node);
    },
  },
};
</script>
